export class GridHeader {
  id!: string;
  schemaName!: string;
  displayName!: string;
  dataType!: string;
  isShown!: boolean;
  isFilterable!: boolean;
  isSortable!: boolean;
  displayOrder!: number;
  entityTypeId!: number;
  entityTypeName!: string;
  readOnly!: boolean;
}
